import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslate } from 'react-admin';

interface AllNoneButtonsProps {
  onSelectAll: () => void;
  onClearAll: () => void;
}

export const AllNoneButtons: React.FC<AllNoneButtonsProps> = ({ onSelectAll, onClearAll }) => {
  const translate = useTranslate();
  return (
    <div style={{ display: 'flex', gap: '5px', marginTop: '8px' }}>
      <Button onClick={onSelectAll} variant="outlined" color="secondary" size="small">
        {translate('osfc.storage_ui.shared.all')}
      </Button>
      <Button onClick={onClearAll} variant="outlined" color="secondary" size="small">
        {translate('osfc.storage_ui.shared.none')}
      </Button>
    </div>
  );
};
